var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Article',{attrs:{"header-image":_vm.tagEditorCover,"title":_vm.title,"header-text":"ux design","section-type-name":"ux design"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('TagEditorBody')]},proxy:true},{key:"icon",fn:function(){return [_c('LumiIcon')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }